import { useEffect, useState } from 'react';
import { Box, Button, Autocomplete, TextField, Typography } from '@material-ui/core';
import { GetOtherPages, PageGroupPageMapping } from './ConnectionService';

const AddExistingSubMenu = ({ onCancel, onSave, userGroupKey }) => {
  const [selectedSubMenu, setSelectedSubMenu] = useState(null);
  const [subMenus, setSubMenus] = useState([]);

  useEffect(() => {
    const fetchSubMenus = async () => {
      if (userGroupKey) {
        const res = await GetOtherPages(userGroupKey);
        setSubMenus(res);
      }
    };

    fetchSubMenus();
  }, [userGroupKey]);

  const handleChange = (event, value) => {
    setSelectedSubMenu(value);
  };

  const handleSave = async () => {
    if (selectedSubMenu) {
      const data = {
        pageKey: selectedSubMenu.pageKey,
        pageGroupKey: selectedSubMenu.pageGroupKey,
        targetUserGroupKey: userGroupKey
      };
      await PageGroupPageMapping(data);
      onSave(selectedSubMenu.pageKey);
    }
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ my: 2 }}>Do you want to add an existing Sub Menu?</Typography>
      <Autocomplete
        options={subMenus}
        getOptionLabel={(option) => option.pageName}
        onChange={handleChange}
        renderInput={(params) => <TextField {...params} label="Select Sub Menu" variant="outlined" />}
        fullWidth
      />
      <Box mt={2}>
        <Button onClick={onCancel} variant="contained" sx={{ background: 'linear-gradient(to bottom, #939ca3, #939ca3)', minWidth: 100 }}>No</Button>
        <Button onClick={handleSave} variant="contained" sx={{ backgroundColor: "linear-gradient(to bottom, #072f40, #072f40)" }}style={{ marginLeft: '8px' }}>Yes</Button>
      </Box>
    </Box>
  );
};

export default AddExistingSubMenu;
